import React from 'react';
import AdminOptions from 'shared/components/AdminOptions';
import { Controls, validators } from 'shared/helper/form';
import { T } from 'shared/helper/translate';
import { JournalSelection } from 'researcher/service-details';
import BoletoUrls from './BoletoUrls';
import FileLink from './FileLink';
import InvoiceAndFapiaoLinks from './InvoiceAndFapiaoLinks';
import OrderDates from './OrderDates';
import OrderServicesFieldset from './OrderServicesFieldset';
var Radio = Controls.Radio;
var notEmpty = validators.notEmpty;
var OrderDetailsSidebar = function OrderDetailsSidebar(_ref) {
  var deadlineMismatch = _ref.deadlineMismatch,
    displayInvoices = _ref.displayInvoices,
    displayJournal = _ref.displayJournal,
    editingOrderDetails = _ref.editingOrderDetails,
    showStyleOfEnglish = _ref.showStyleOfEnglish,
    journalSelectionRequired = _ref.journalSelectionRequired,
    methods = _ref.methods,
    newDeadline = _ref.newDeadline,
    newServiceIdentities = _ref.newServiceIdentities,
    onServiceAdded = _ref.onServiceAdded,
    onServiceRemoved = _ref.onServiceRemoved,
    order = _ref.order,
    updateDeadline = _ref.updateDeadline;
  return /*#__PURE__*/React.createElement("div", {
    className: "pt-2 pb-3 order-information-column order-details-sidebar"
  }, /*#__PURE__*/React.createElement(OrderDates, {
    deadlineAvailable: order.deadlineAvailable || newDeadline,
    deadlineMismatch: deadlineMismatch,
    editingOrderDetails: editingOrderDetails,
    newDeadline: newDeadline,
    order: order,
    updateDeadline: updateDeadline,
    showExactTime: true
  }), /*#__PURE__*/React.createElement(OrderServicesFieldset, {
    editingOrderDetails: editingOrderDetails,
    methods: methods,
    onAdd: onServiceAdded,
    onRemove: onServiceRemoved,
    orderServices: order.services,
    removable: editingOrderDetails && order.inProgress,
    serviceOptions: order.serviceOptions
  }), order && order.primaryManuscripts && order.primaryManuscripts.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(T, {
    source: "Original Files"
  })), order.primaryManuscripts.map(function (item) {
    return /*#__PURE__*/React.createElement(FileLink, {
      key: item.identity,
      file: item
    });
  })) : null, displayInvoices ? /*#__PURE__*/React.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(T, {
    source: "Payment"
  })), /*#__PURE__*/React.createElement(InvoiceAndFapiaoLinks, {
    orderNumber: order.externalId
  }), /*#__PURE__*/React.createElement(BoletoUrls, {
    order: order
  })) : null, !editingOrderDetails ? /*#__PURE__*/React.createElement(React.Fragment, null, order.journal && order.journal.name && displayJournal ? /*#__PURE__*/React.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(T, {
    source: "Target Journal"
  })), /*#__PURE__*/React.createElement("div", null, order.journal.name)) : null, showStyleOfEnglish && /*#__PURE__*/React.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(T, {
    source: "Style of English"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(T, {
    source: order.styleOfEnglish
  })))) : /*#__PURE__*/React.createElement(AdminOptions, null, /*#__PURE__*/React.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(T, {
    source: "Target Journal"
  })), /*#__PURE__*/React.createElement(JournalSelection, {
    alwaysDisplayed: true,
    required: journalSelectionRequired,
    styles: {
      journalSelectionWrapper: 'col-md-12'
    },
    serviceIdentities: newServiceIdentities,
    methods: methods
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement(Radio, {
    label: "Style of English",
    messages: {
      notEmpty: 'Please select your preferred type of English.'
    },
    name: "styleOfEnglish",
    validators: {
      notEmpty: notEmpty
    },
    options: [{
      value: 'British',
      label: /*#__PURE__*/React.createElement(T, {
        source: "British"
      })
    }, {
      value: 'American',
      label: /*#__PURE__*/React.createElement(T, {
        source: "American"
      })
    }]
  }))));
};
export default OrderDetailsSidebar;